import Button from "components/Button/Button";
import RouterStore from "stores/RouterStore";
import { observer } from "mobx-react";
import { FaCheck, FaInfoCircle } from "react-icons/fa";
import React, { useState } from "react";
import UserStore from "stores/UserStore";
import Modal from "react-modal";
import "./LGE.scss";

import NFTStore from "stores/NFTStore";
const mediaQuery = window.matchMedia("(max-width: 1024px)");
const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#9ea9cf",
    width: mediaQuery.matches ? "100%" : "25%",
    height: "65%",
    padding: "0px",
    margin: "0px",
  },
};
Modal.setAppElement("#root");

type Currencies = "ETH" | "YGY";

const handleClick = (currencyBeingSet, setCurrency, setInputValue) => {
  setCurrency(currencyBeingSet);
  setInputValue(undefined);
};

const handleInputChange = (value: number, max: number, setInputValue) => {
  if (value <= max) {
    setInputValue(value);
  } else {
    setInputValue(undefined);
  }
};

const validateInput = (value: number, currencyMax: number) => {
  return value <= currencyMax;
};

function LGE() {
  const [currency, setCurrency] = useState<Currencies>("YGY");
  const [autoStake, setAutoStake] = useState<boolean>(true);
  const [infoModalOpen, setInfoModalOpen] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<number | undefined>(undefined);

  const requireApproval = () => {
    if (currency !== "YGY") return false;
    const result = UserStore.allowances.get("Router");
    if (result) {
      const allowance = result.find((allowance) => allowance.tokenName === "YGY");
      return !allowance?.hasAllowance;
    } else {
      return true;
    }
  };

  const balances = {
    YGY: UserStore.balances.get("YGY"),
    ETH: UserStore.balances.get("ETH"),
  };
  const { userLevel, userEthDeposited } = RouterStore;
  const { unclaimedRobot } = NFTStore;
  const canConvert = inputValue && validateInput(inputValue, balances[currency]!);

  return (
    <div className="item lge">
      <div className="item-header">
        Get YGY/RAM liquidity
        <FaInfoCircle
          className="clickable"
          onClick={() => setInfoModalOpen(true)}
          style={{ marginTop: "4px", border: "2px solid #2c2b2b", borderRadius: "50px" }}
        />
      </div>
      <div className="item-content">
        <div className="section-lge">
          <div className="section-title section-title-lge">
            Choose ETH / YGY <br />
            your total: {userEthDeposited}ETH - level {userLevel}{" "}
          </div>
          {unclaimedRobot > 0 && (
            <div className="section-item-robot clickable" onClick={() => RouterStore.claimRobot()}>
              Claim a ROBOT NFT
            </div>
          )}
          <div
            className={`section-item top-level-item checkboxed ${currency === "ETH" ? "checked" : ""}`}
            onClick={() => handleClick("ETH", setCurrency, setInputValue)}
          >
            <div className="section-item-title">ETH</div>
            <div className="section-item-value">wallet: {balances.ETH ? balances.ETH.toFixed(3) : 0}</div>
          </div>
          <div
            className={`section-item top-level-item checkboxed ${currency === "YGY" && "checked"}`}
            onClick={() => handleClick("YGY", setCurrency, setInputValue)}
          >
            <div className="section-item-title">YGY</div>
            <div className="section-item-value">wallet: {balances.YGY ? balances.YGY.toFixed(3) : 0}</div>
          </div>
          <div className="section-title section-title-lge section-title-amount">Amount to convert</div>
          <div className="lge-input-container">
            <input
              className="section-lge-input"
              type="number"
              value={inputValue}
              placeholder={`${currency} amount to convert`}
              onChange={(e) => handleInputChange(parseFloat(e.target.value), balances[currency]!, setInputValue)}
            />
            <Button type="neutral" className="lge-input-button" onClick={() => setInputValue(balances[currency])}>
              Max
            </Button>
          </div>
          <div
            className={`section-item top-level-item section-item-autostake checkboxed ${autoStake ? "checked" : ""}`}
            onClick={() => setAutoStake((val) => !val)}
          >
            <div className="section-item-value checkmark">Auto-stake the liquidity to vault {autoStake ? <FaCheck /> : null}</div>
          </div>
          {!requireApproval() ? (
            <Button
              type="positive"
              className={`lge-convert-button ${!canConvert && "disabled"}`}
              onClick={() => currency && inputValue && RouterStore.addLiquidity(currency, inputValue, autoStake)}
            >
              Convert
            </Button>
          ) : (
            <Button type="positive" className={`lge-convert-button`} onClick={() => UserStore.getAllowance("YGY", "Router")}>
              Approve YGY before you can convert!
            </Button>
          )}
        </div>
        <Modal
          isOpen={infoModalOpen}
          onRequestClose={() => setInfoModalOpen(false)}
          contentLabel="Liquidity prodiving info"
          style={modalStyles}
        >
          <div
            style={{
              width: "100%",
              padding: "2p 9px",
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <h2>Liquidity generator</h2>
            <p>This component will automatically purchase an optimal amount of RAM with your YGY or ETH deposit.</p>
            <p>
              After doing so the tokens will be provided as liquidity to the Uniswap{" "}
              <a
                href="https://info.uniswap.org/pair/0xdeaca5ae8a9426e4c9e2ea14d7223ca251ce7e5a"
                target="blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "blue", fontWeight: "bold" }}
              >
                {" "}
                YGY/RAM pool.
              </a>{" "}
            </p>
            <p>You have the option to auto-deposit the tokens straight to the vault.</p>
            <p>
              <b>
                This liquidity, whether provided through the generator OR Uniswap UI itself cannot be redeemed back for the underlying
                assets (unwrapped)!
              </b>
            </p>
            <p>
              You may currently use the LP tokens for: <br />
              <br />
              <b>YGY/RAM Vault</b> <br /> <b>RAM pool</b>
              <br />
              <b>YGY pool</b> <br />
              <br />
            </p>
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default observer(LGE);
